import {
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject } from 'rxjs';

import SwiperCore, {
  Keyboard,
  Pagination,
  Navigation,
  Virtual,
  SwiperOptions,
} from 'swiper';
import { MyLearningService } from './my-learning.service';

SwiperCore.use([Keyboard, Pagination, Navigation, Virtual]);

@Component({
  selector: 'app-my-learning',
  templateUrl: './my-learning.component.html',
  styleUrls: ['./my-learning.component.scss']
})
export class MyLearningComponent implements OnInit {

  @ViewChild('editModal')
  editModal!: TemplateRef<any>;

  config: SwiperOptions = {
    slidesPerView: 3,
    spaceBetween: 50,

    navigation: true,
    pagination: { clickable: true },
    scrollbar: { draggable: true },
  };

  math = Math;
  slides$ = new BehaviorSubject<string[]>(['']);

  images = [944, 1011, 984].map((n) => `https://picsum.photos/id/${n}/900/500`);
  programData: any;
  currentEnrolments: any;
  isCompleted: any;
  loading = true;
  currentCourse: any[] = [];
  achievePendingPrograms: any;
  constructor(
    private myLearningService: MyLearningService,
    private modalService: NgbModal,
    private router: Router
  ) {}

  async ngOnInit() {
    await this.getAchieveProgramByStatus();
    // await this.getAchievePrograms();
    await this.getPrograms();
    this.getCurrentEnrolmentsCourse();
    this.slides$.next(
      Array.from({ length: 600 }).map((el, index) => `Slide ${index + 1}`)
    );
    // this.checkCourseCompletion();
  }

  getUser() {
    return localStorage.getItem('username');
  }

  getGroupId() {
    return localStorage.getItem('groupId');
  }
  getOrgId() {
    return localStorage.getItem('orgId');
  }

  async getPrograms() {
    const orgId = this.getOrgId();
    const groupId = this.getGroupId();
    this.programData = await this.myLearningService.getPrograms(orgId, groupId);
    // console.log(this.programData);
    await this.getCurrentEnrolments();
    console.log('this.programData', this.programData.programs);
    for (let i = 0; i < this.programData.programs.length; i++) {
      const courses: any = [];
      this.programData.programs[i].courses.forEach((e1: any, j: number) => {
        const programCourseId = e1.courseId;
        const courseEnrollIndex = this.currentEnrolments.findIndex(
          (c: any) => c.courseid === programCourseId
        );
        if (courseEnrollIndex !== -1) {
          courses.push({
            ...this.programData.programs[i].courses[j],
            ...this.currentEnrolments[courseEnrollIndex],
            courseId: this.currentEnrolments[courseEnrollIndex].courseid,
            isCourseEnrolled: true,
          });
        } else {
          courses.push({
            ...this.programData.programs[i].courses[j],
            progressCompleted: 0,
            startDate: 'Not Started',
            isCourseEnrolled: false,
          });
        }
      });
      this.programData.programs[i].courses = courses;
      console.log(
        'this.programData.courses',
        this.programData.programs[i].courses
      );
    }
    this.loading = false;
  }

  async getCurrentEnrolments() {
    const userName = this.getUser();
    let enrolmentData: any = await this.myLearningService.getCurrentEnrolments(
      userName
    );
      this.currentEnrolments = enrolmentData.data;
      // console.log('currentEnrolments', this.currentEnrolments);
  }

  async getCurrentEnrolmentsCourse() {
    const userName = this.getUser();
    let enrolmentData: any = await this.myLearningService.getCurrentEnrolments(userName);
    enrolmentData.data.forEach((el:any) => {
      // console.log('el',el)
      if(el.progressCompleted !== "100"){
        this.currentCourse.push(el);
        console.log('this.currentCourse',this.currentCourse)
      }
    });
  }

  showVideo(courseid: string, courseVer: string) {
    const username = this.getUser();

    window.open(
      `https://player.videosity.net/ignite-dev.php?courseid=${courseid}&courseVer=${courseVer}&userid=${username}`,
      '_blank'
    );
  }

  async getAchieveProgramByStatus(){
    this.achievePendingPrograms = await this.myLearningService.getAchieveProgramByStatus('pending');
    console.log('achievePendingPrograms', this.achievePendingPrograms);
  }

  onClickLaunch(
    courseid: string,
    courseVer: string,
    programIndex: any,
    coursesIndex: any
  ) {
    console.log(coursesIndex);

    const username = this.getUser();
    if (coursesIndex === 0) {
      this.showVideo(courseid, courseVer);
    } else if (this.programData.programs[programIndex].enforceOrder === '1') {
      if (
        this.programData.programs[programIndex].courses[coursesIndex - 1]
          .progressCompleted != 100
      ) {
        this.modalService.open(this.editModal);
      } else {
        if (!courseid && !courseVer && !username) {
          alert('Something went wrong');
        } else {
          this.showVideo(courseid, courseVer);
        }
      }
    }
  }

  // getCourseData(id:string){
  //   // console.log(id)
  //   const course = this.currentEnrolments.find((item: any) => item.courseid === id);
  //   // console.log(course);
  //   return course
  // }

  getImage(img: string) {
    const url = `https://s3-ap-southeast-2.amazonaws.com/${img}`;
    return url;
  }

  onClickContinue(programId: string, userId: string) {
    this.router.navigate([`achieve-program-data/${programId}/${userId}`])
  }

}
